module.exports = __webpack_public_path__ + "static/media/out_of_stock_radio.469bded5.svg";